<div class="lgoinPageWrapper">
    <div class="bg">
        <div class="items" [ngClass]="{active : i == activeIndex }" *ngFor="let item of data; let i = index;">
            <img [src]="!isMobile ? item.img : item.imgMob " alt="">
            <div class="filmTitle">{{item.title}}</div>
        </div>

        <div class="overlay"></div>

        <a routerLink="/contact" class="contact">Contact Us</a>
    </div>



    <div class="loginWreppaer">
        <div class="login-container" [class]="active">
            <!-- <mat-card class="login-card">
                <mat-card-header>
                    <mat-card-title>Login</mat-card-title>
                </mat-card-header>
                <mat-card-content> -->
            <div class="formWrap">

                <!-- <div class="logo">
                    <img src="assets/login-logo.png" alt="">
                    
                </div> -->

                <div class="welcome"
                    *ngIf="active == 'splash' || active == 'login' || active == 'step1'  || active == 'step2' || active == 'step1-mfa' || active == 'login-2FA' || active == 'thankyou' || active == 'finish' ">
                    <img src="assets/Lionsgate-Repertory-logo.png" alt="">
                </div>

                <div class="splashHolder" *ngIf="active == 'splash'">
                    <div class="explore">
                        EXPLORE OUR CATALOG
                    </div>
                    <div class="browse">
                        Browse through thousands of our titles for your movie theater
                    </div>

                    <div class="loginButton">
                        <div class="roundButton" (click)="onOpenLogin()">
                            <div class="label">Log In</div>
                        </div>
                    </div>

                    <div class="noAccount">
                        <div class="naText">
                            Don't have an account?
                        </div>

                        <div class="roundButton buttonAccess" (click)="onOpenRequest()">
                            <div class="label">
                                Request Access
                            </div>
                        </div>
                    </div>
                </div>

                <div class="loginHolder" *ngIf="active == 'login'">
                    <form (ngSubmit)="login()">
                        <div class="titleLine">
                            <div class="login">Log In</div>
                            <div class="close" (click)="onCloseLogin()">
                                <mat-icon>close</mat-icon>
                            </div>
                        </div>

                        <div class="inputWrapper">
                            <div class="label">
                                Email
                            </div>
                            <input id="email" type="email" name="email" [(ngModel)]="email" required>
                            <!-- <mat-error>Please enter a valid email address</mat-error> -->
                        </div>

                        <div class="inputWrapper">
                            <div class="label">
                                Password
                            </div>
                            <input [type]="!isPasswordVisible ? 'password' : 'text' " id="password" name="password"
                                [(ngModel)]="password" required>
                            <div class="showPassword" (click)="passwordVisibleToggle()">
                                <mat-icon *ngIf="isPasswordVisible">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible">visibility_off</mat-icon>
                            </div>
                        </div>
                        <!-- <mat-form-field appearance="fill" class="full-width"> -->

                        <!-- <mat-label>Email</mat-label> -->
                        <!-- <input matInput id="email" type="email" name="email" [(ngModel)]="email" placeholder="Enter your email" required> -->
                        <!-- <mat-icon matSuffix>email</mat-icon> -->
                        <!-- </mat-form-field> -->

                        <!-- <mat-form-field appearance="fill" class="full-width">
                            <mat-label>Password</mat-label>
                            <input matInput type="password" id="password" name="password" [(ngModel)]="password"
                                placeholder="Enter your password" required>
                            <mat-icon matSuffix>lock</mat-icon>
                            <mat-error>Please enter your password</mat-error>
                        </mat-form-field> -->

                        <div class="buttonWrap">

                            <!-- <button class="roundButton"> -->
                            <button class="submitButton full">
                                <div class="label">Enter</div>
                            </button>
                        </div>

                        <!-- <button mat-raised-button color="primary" class="full-width" type="submit">Login</button> -->

                        <div class="forgot-password">
                            <a (click)="onForgotPassword()">Forgot Your Password?</a>
                        </div>
                    </form>
                </div>

                <div class="passwordChangeRequest" *ngIf="active == 'passwordChange'">
                    <div class="box">
                        <div class="close" (click)="onForgotPasswordClose()">
                            <mat-icon>close</mat-icon>
                        </div>
                        <div class="title">
                            Password change request
                        </div>
                        <div class="subTitle">
                            Send a link to reset your password.
                        </div>
                        <div class="inputHolder">
                            <div class="smallLabel">Your Email</div>
                            <input type="text" [(ngModel)]="email">
                        </div>

                        <div class="buttonWrapSendLink">
                            <div class="sendLink roundButton black" (click)="onForgotPasswordSubmit()">
                                <div class="label">Email Link</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="passwordChangeRequest" *ngIf="active == 'passwordChange-result'">
                    <div class="box">
                        <div class="close" (click)="onForgotPasswordClose()">
                            <mat-icon>close</mat-icon>
                        </div>
                        <div class="title">
                            Password change request
                        </div>
                        <div class="subTitle">
                            An email has been sent to:
                        </div>
                        <div class="subTitle">
                            {{email}}
                        </div>

                        <div class="subTitle sub2">
                            Click the button on the email to <br>
                            reset and choose a new password.
                        </div>
                    </div>
                </div>

                <div class="loginHolder" *ngIf="active == 'login-2FA'">
                    <form (ngSubmit)="loginSecondFactorCode()">
                        <div class="titleLine">
                            <div class="login">Log In</div>
                            <!-- <div class="close" (click)="onCloseLogin()">
                                <mat-icon>close</mat-icon>
                            </div> -->
                        </div>

                        <div class="inputWrapper">
                            <div class="loginExpl">An SMS Code was just sent. Please check your cell phone.</div>
                            <div class="split">
                                <div class="cellNumber" [innerHTML]="mfaPhoneNumber | phoneNumber"></div>
                                <!-- <div class="cellNumber" [innerHTML]="authService.profile.phone | phoneNumber"></div> -->
                                <div class="reSend">
                                    
                                </div>
                            </div>
                            <!-- <div class="loginExpl resend">If you haven’t received an SMS code,<br>please <a (click)="reSendCode()">CLICK HERE TO RESEND CODE</a></div> -->
                            <div class="label">
                                Enter Code from SMS
                            </div>
                            <input id="code" type="text" name="code" [(ngModel)]="code" required>
                            <div class="inputError" [innerHTML]="codeError | safeHtml"></div>
                            <!-- <mat-error>Please enter a valid email address</mat-error> -->
                        </div>


                        <div class="buttonWrap">

                            <button class="submitButton full">
                                <div class="label">Enter</div>
                            </button>
                        </div>

                        <div class="inputWrapper resendWrapper">
                            <div class="smallInfo">
                                Didn't receive the SMS code from Lionsgate Repertory?
                            </div>
                        </div>
                        <div class="submitButton resend" (click)="reSendCode()">
                            <div class="label">Resend Code</div>
                        </div>
                        <div class="inputWrapper helpWrapper">
                            <div class="smallInfo">
                                Need Help? Contact <a href="mailto:Support@lionsgaterepertory.com" target="_blank">Support&#64;lionsgaterepertory.com</a>
                            </div>
                        </div>

                        <!-- <div class="inputWrapper resendWrapper">
                            <div class="smallInfo">
                                Didn't receive the SMS code from Lionsgate Repertory?
                            </div>
                        </div>
                        <div class="submitButton resend" (click)="reSendCode()">
                            <div class="label">Resend Code</div>
                        </div> -->


                    </form>
                </div>

                <div class="requestHolder" *ngIf="active == 'request'">
                    <div class="split">
                        <div class="left">
                            <div class="wrp">
                                <div class="rLogo">
                                    <img src="assets/Lionsgate-Repertory-logo.png" alt="">
                                </div>
                            </div>
                            <div class="text">
                                You will need a registered account to explore<br>the Lionsgate Repertory Catalog. <br>
                                Let’s get started.
                            </div>
                            <div class="arrowWrap">

                                <div class="arrow">
                                    <img src="assets/login/arrow.png" alt="">
                                </div>
                            </div>

                            <div class="q">
                                Already have an account?
                            </div>
                            <div class="loginButton">
                                <div class="roundButton" (click)="onOpenLogin()">
                                    <div class="label">Log In</div>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="titleLine">
                                <div class="login">Request Account</div>
                                <div class="close" (click)="onCloseLogin()">
                                    <mat-icon>close</mat-icon>
                                </div>
                            </div>

                            <form (ngSubmit)="request()">
                                <div class="splitInput">
                                    <div class="inputWrapper">
                                        <div class="label">
                                            First Name
                                        </div>
                                        <input id="firstName" type="text" name="firstName" [(ngModel)]="firstName"
                                            required>
                                    </div>

                                    <div class="inputWrapper">
                                        <div class="label">
                                            Last Name
                                        </div>
                                        <input id="lastName" type="text" name="lastName" [(ngModel)]="lastName"
                                            required>

                                    </div>
                                </div>
                                <div class="inputWrapper">
                                    <div class="label">
                                        Email
                                    </div>
                                    <input id="email" type="email" name="email" [(ngModel)]="email" required>
                                </div>
                                <div class="inputWrapper">
                                    <div class="label">
                                        Phone Number
                                    </div>
                                    <input id="phone" type="text" name="phone" [(ngModel)]="phone"
                                        placeholder="(XXX) XXX-XXXX"  required appPhoneMask> 
                                        <!--   -->
                                        
                                </div>

                                <!-- <div class="splitInput">
                                    <div class="inputWrapper">
                                        <div class="label">
                                            Password
                                        </div>
                                        <input id="firstName" type="password" name="firstName" [(ngModel)]="password"
                                            required>
                                    </div>

                                    <div class="inputWrapper">
                                        <div class="label">
                                            Verify Password
                                        </div>
                                        <input id="lastName" type="password" name="lastName" [(ngModel)]="rePassword"
                                            required>

                                    </div>
                                </div> -->

                                <div class="submitButton" (click)="onRequestSubmit()">
                                    <div class="label">Submit Request</div>
                                </div>

                                <div class="expl">
                                    A Lionsgate Repertory represenative <br>
                                    will follow up with your request.
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="step1" *ngIf="active == 'step1'">
                    <div class="topProgress">
                        <div class="text1">
                            Complete Account Setup
                        </div>
                        <div class="stepCount">
                            2 of 2
                        </div>
                    </div>

                    <!-- <div class="verifyEmail" > -->
                    <!-- <div class="text1" *ngIf="!authService.isEmailVerified()">
                            Please verify your email address from the link we've sent you when you submitted your
                            request.
                            <br><br>
                            If you haven't received a verifiaction email press the button and we'll send you a new one.
                        </div> -->

                    <!-- <div class="submitButton" (click)="onReSendVerificationEmail()"
                            [ngClass]="{disabled: verificationEmailSent}">
                            <div class="label">Send verification email</div>
                        </div> -->
                    <!-- </div> -->

                    <form (ngSubmit)="stepOneCompleteRegistration()">
                        <div class="splitInput">
                            <div class="inputWrapper">
                                <div class="label">
                                    First Name
                                </div>
                                <input id="firstName" type="text" name="firstName" [(ngModel)]="firstName" required
                                    disabled>
                            </div>

                            <div class="inputWrapper">
                                <div class="label">
                                    Last Name
                                </div>
                                <input id="lastName" type="text" name="lastName" [(ngModel)]="lastName" required
                                    disabled>

                            </div>

                        </div>
                        <!-- <div class="values">

                        
                            <div class="val">
                                {{firstName}} {{lastName}}
                            </div>
                        </div> -->
                        <div class="inputWrapper">
                            <div class="label">
                                Email
                            </div>
                            <input id="email" type="email" name="email" [(ngModel)]="email" required disabled>
                            <!-- <div class="values">

                             
                                <div class="val">
                                    {{email}}
                                </div>
                            </div> -->
                        </div>
                        <div class="inputWrapper">
                            <!-- <div class="values">

                                <div class="name">
                                    Phone Number:
                                </div>
                                <div class="val">
                                    {{phone}}
                                </div>
                            </div> -->

                            <!-- <div class="label">
                                Phone Number
                            </div>
                            <input id="phone" type="text" name="phone" [(ngModel)]="phone" required>
                            <mat-error>Please enter a valid email address</mat-error> -->
                        </div>



                        <div class="inputWrapper">
                            <div class="label">
                                Password
                            </div>
                            <input id="password" [type]="!isPasswordVisible ? 'password' : 'text' " name="password"
                                [(ngModel)]="password" (ngModelChange)="onPasswordChange($event)" required>
                            <div class="showPassword" (click)="passwordVisibleToggle()">
                                <mat-icon *ngIf="isPasswordVisible">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible">visibility_off</mat-icon>
                            </div>
                        </div>

                        <div class="strength-meter">
                            <div class="strength-bar" [ngClass]="passwordStrength().strength"
                                [style.width.%]="passwordStrength().score * 25"></div>
                        </div>
                        <p>Strength: {{ passwordStrength().strength }}</p>
                        <ul>
                            @for (feedback of passwordStrength().feedback; track feedback) {
                            <li>{{ feedback }}</li>
                            }
                        </ul>
                        <p *ngIf="passwordStrength().isValid" class="valid">Password is valid!</p>

                        <div class="inputWrapper">
                            <div class="label">
                                Retype Password
                            </div>
                            <input id="rePassword" [type]="!isPasswordVisible2 ? 'password' : 'text' " name="rePassword"
                                [(ngModel)]="rePassword" required (ngModelChange)="onRePasswordChange($event)">
                            <div class="showPassword" (click)="passwordVisibleToggle2()">
                                <mat-icon *ngIf="isPasswordVisible2">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible2">visibility_off</mat-icon>
                            </div>
                        </div>

                        <!-- <div class="inputWrapper">
                            <mat-checkbox [checked]="enableMultiFactor" (change)="update($event.checked)">
                                Enable multi factor identification
                            </mat-checkbox>
                        </div> -->

                        <div class="submitButton" (click)="stepOneCompleteRegistration()"
                            [ngClass]="{disabled: isNextButtonDisabled}">
                            <div class="label">Next</div>
                        </div>

                    </form>
                </div>


                <div class="step2" *ngIf="active == 'step2'">
                    <div class="topProgress">
                        <div class="text1">
                            Complete Account Setup
                        </div>
                        <div class="stepCount">
                            2 of 2
                        </div>
                    </div>
                    <form (ngSubmit)="onStepPhone()">
                        <div class="smallInfo" [ngClass]="{red: enableMultiFactor}">
                            NOTE: If multiple people will share one email address to access the site, please do not enable Multi-Factor Authentication (MFA) at this time.
                        </div>

                        <div class="inputWrapper">
                            <div class="label">
                                Cell Phone Number
                            </div>
                            <input id="code" type="text" name="code" [(ngModel)]="phone" placeholder="(XXX) XXX-XXXX"
                                appPhoneMask required>
                        </div>

                        <div class="inputWrapper">
                            <mat-checkbox [checked]="enableMultiFactor" (change)="update($event.checked)">
                                Connect My Cell Phone Number <br>
                                For Multi Factor Authentication
                            </mat-checkbox>
                        </div>

                        <div class="submitButton" (click)="onStepPhone()" *ngIf="enableMultiFactor">
                            <div class="label">Next</div>
                        </div>
                        <div class="submitButton" (click)="onFinish()" *ngIf="!enableMultiFactor">
                            <div class="label">Finish</div>
                        </div>
                    </form>
                </div>

                <div class="step1 step1-mfa" *ngIf="active == 'step1-mfa'">
                    <div class="topProgress">
                        <div class="text1">
                            Complete Account Setup
                        </div>
                        <div class="stepCount">
                            2 of 2
                        </div>
                    </div>
                    <form (ngSubmit)="onStepOneMFA()">

                        <div class="inputWrapper">
                            <div class="smallInfo">
                                A SMS Code was just sent. Please check your cell phone. <br><br>
If you want to skip this step, go back and do not opt in for Multi Factor Authentication.
                            </div>
                            <div class="label">
                                Enter Code From SMS
                            </div>
                            <input id="code" type="text" name="code" [(ngModel)]="verificationCode" required>
                        </div>

                        <div class="submitButton" (click)="onStepOneMFA()">
                            <div class="label">Finish</div>
                        </div>

                        <div class="inputWrapper resendWrapper">
                            <div class="smallInfo">
                                Didn't receive the SMS code from Lionsgate Repertory?
                            </div>
                        </div>
                        <div class="submitButton resend" (click)="onResendCode()">
                            <div class="label">Resend Code</div>
                        </div>

                        <div class="inputWrapper helpWrapper">
                            <div class="smallInfo">
                                Need Help? Contact <a href="mailto:Support@lionsgaterepertory.com" target="_blank">Support&#64;lionsgaterepertory.com</a>
                            </div>
                        </div>
                    </form>
                </div>


                <div class="step1 step1-mfa thankyou" *ngIf="active == 'thankyou'">

                    <div class="text1">
                        Your request for an account is being reviewed
                    </div>
                </div>

                <div class="finish" *ngIf="active == 'finish' ">
                    <div class="topProgress">
                        <div class="text1">
                            You’re All Set!
                        </div>
                        <div class="stepCount">

                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="data"
                            [innerHTML]="authService.profile.firstName + ' ' + authService.profile.lastName | safeHtml">
                        </div>
                        <div class="data" [innerHTML]="authService.profile.email | safeHtml"></div>
                        <div class="data">
                            <span *ngIf="!isPasswordVisible">
                                password: ********
                            </span>
                            <span *ngIf="isPasswordVisible">
                                password: {{password}}
                            </span>

                            <div class="showPasswordFinish" (click)="passwordVisibleToggle()">
                                <mat-icon *ngIf="isPasswordVisible">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible">visibility_off</mat-icon>
                            </div>
                        </div>
                        <div class="data">
                            cell phone #: <span [innerHTML]="authService.profile.phone | phoneNumber"></span>

                        </div>
                    </div>

                    <div class="buttonHolder">
                        <a routerLink="/">

                            <div class="browse roundButton white">
                                <div class="label">Browse The Site</div>
                            </div>
                        </a>

                    </div>
                </div>

            </div>
            <!-- </mat-card-content> -->
            <!-- <mat-card-actions>
                <p>Don't have an account? <a mat-button href="#">Sign Up</a></p>
              </mat-card-actions> -->
            <!-- </mat-card> -->
        </div>
    </div>
    <!-- reCAPTCHA Container (invisible) -->
    <div #recaptchaContainer></div>
</div>